if (!customElements.get('ks-gallery')) {
  customElements.define('ks-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-gallery-art]');
        if (!link || !this.contains(link) || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.opener = link;
        this.querySelector('[data-gallery-viewer-title]').textContent = link.dataset.galleryTitle;
        const image = this.querySelector('[data-gallery-viewer-image]');
        image.alt = link.dataset.galleryAlt;
        image.src = link.href;
        this.previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.dialog.showModal();
      }, options);
      this.querySelector('[data-gallery-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => this.restorePage(), options);
    }

    restorePage() {
      if (this.previousOverflow !== undefined) {
        document.body.style.overflow = this.previousOverflow;
        this.previousOverflow = undefined;
      }
      if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
      this.opener = null;
    }

    disconnectedCallback() {
      this.restorePage();
      this.controller?.abort();
      this.controller = null;
    }
  });
}
